import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {TagEditState, TagEditView} from "@app/tag/models";

@Component({
    selector: 'frog-add-remove-tag',
    templateUrl: './add-remove-tag.component.html',
    styleUrls: ['./add-remove-tag.component.scss'],
    imports: [MatIcon],
})
export class AddRemoveTagComponent implements OnInit {
    @Input() tag: TagEditView;
    @Output() OnChange: EventEmitter<any>;

    constructor() {
        this.OnChange = new EventEmitter<any>();
    }

    ngOnInit(): void {}

    add() {
        this.tag.state = this.tag.state === TagEditState.Add ? TagEditState.Any : TagEditState.Add;
        this.OnChange.emit();
    }

    remove() {
        this.tag.state =
            this.tag.state === TagEditState.Remove ? TagEditState.Any : TagEditState.Remove;
        this.OnChange.emit();
    }
}
